import styled from "styled-components";

export const StyleImg = styled.img.attrs((props) => ({
  src: props.src,
  title: props.title,
  alt: props.alt
}))`
  display: ${(props) => (props.src?.length ? props.display : "none")};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  bottom: ${(props) => props.bottom};
  left: ${(props) => props.left};
  z-index: ${(props) => props.zIndex};
  min-width: ${(props) => props.minWidth};
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  min-height: ${(props) => props.minHeight};
  height: ${(props) => props.height};
  max-height: ${(props) => props.maxHeight};
  margin: ${(props) => props.margin};
  margin-right: ${(props) => props.marginRight};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  padding: ${(props) => props.padding};
  border: ${(props) => props.border};
  border-radius: ${(props) => props.borderRadius};
  cursor: ${(props) => props.cursor};
  float: ${(props) => props.float};
  object-fit: ${(props) => props.objectFit};
  vertical-align: ${(props) => props.verticalAlign};
  background-color: ${(props) => props.backgroundColor};
  mix-blend-mode: ${(props) => props.mixBlendMode};
  color: ${(props) => props.color};
  filter: ${(props) => props.filter};
`;
